import { CustomState } from "@bevco/Store/Reducers";
import {
    getProductListDataView,
    getProductListDataViewProperty,
} from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, FacetModel } from "@insite/client-framework/Types/ApiModels";

export const formatNumberWithCommas = (number: any): string => {
    const result = number.toString().replace(/,/g, ""); // remove commas from existing input
    const parts = result.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
};

export const formatDateToMonthDay = (originalDate: string) => {
    if (!originalDate) {
        return "";
    }

    const date = new Date(originalDate.replace(/-/g, "/"));
    const month = date.toLocaleString("default", { month: "long" });
    return `${month} ${date.getDate()}`;
};

export const searchFilteringStateValues = (state: CustomState, all = false) => {
    const {
        pages: {
            productList: {
                productFilters: { pageCategoryId },
            },
        },
        customProductList: { isLoadingFilter: loading },
    } = state;

    const isCategoryPage = pageCategoryId !== undefined;

    let brandFacets: FacetModel[] = [];
    let productLineFacets: FacetModel[] = [];
    let categoryFacets: FacetModel[] = [];
    let attributeTypeFacets: {
        id: string;
        name: string;
        items: FacetModel[];
    }[] = [];

    if (getProductListDataView(state).value) {
        brandFacets = getProductListDataViewProperty(state, "brandFacets") ?? [];

        productLineFacets = getProductListDataViewProperty(state, "productLineFacets") ?? [];

        categoryFacets = !isCategoryPage
            ? (getProductListDataViewProperty(state, "categoryFacets") ?? []).map<FacetModel>(facet => ({
                  id: facet.categoryId,
                  name: facet.shortDescription,
                  count: facet.count,
                  selected: facet.selected,
              }))
            : [];

        attributeTypeFacets = (getProductListDataViewProperty(state, "attributeTypeFacets") ?? []).map(groupFacet => ({
            id: groupFacet.attributeTypeId,
            name: groupFacet.name,
            items: (groupFacet.attributeValueFacets ?? []).map(facet => ({
                id: facet.attributeValueId,
                name: facet.value,
                count: facet.count,
                selected: facet.selected,
            })),
        }));
    }

    const dataView = getProductListDataView(state);

    return {
        loaded: dataView.value,
        loading,
        brandFacets,
        productLineFacets,
        categoryFacets,
        attributeTypeFacets,
    };
};

export const parseOrderType = (orderType = "", isQuote?: boolean) => {
    switch (orderType.toUpperCase()) {
        case "CARS":
            return isQuote ? translate("AIR Quote") : translate("AIR Order");
        case "EDI":
            return isQuote ? translate("EDI Quote") : translate("EDI Order");
        case "OCR":
            return translate("Sales Rep");
        case "WEB":
            return isQuote ? translate("Web Quote") : translate("Web Order");
        case "SA":
            return isQuote ? translate("Scheduled Quote") : translate("Scheduled Order");
        default:
            return "Sales Rep";
    }
};

export const getLooseEndsText = (cartLine: CartLineModel) => {
    if (!cartLine?.properties) {
        return "";
    }

    if (cartLine.properties["isBackOrder"] !== undefined && cartLine.properties["isBackOrder"] === "true") {
        return "";
    }

    const iscLooseEnds = cartLine.properties["isc_looseEnds"];
    const looseEnds = cartLine.properties["looseEnds"];

    // First check explicit isc_looseEnds values
    if (iscLooseEnds === "No") {
        return "Never Loose Ends";
    }

    if (iscLooseEnds === "Yes") {
        return "Allow Loose Ends-YES";
    }

    // Then check if isc_looseEnds is empty/undefined and looseEnds has a value
    if ((!iscLooseEnds || iscLooseEnds === "") && looseEnds === "Yes") {
        return "Allow Loose Ends-YES";
    }

    if ((!iscLooseEnds || iscLooseEnds === "") && looseEnds === "No") {
        return "Allow Loose Ends-NO";
    }

    return "";
};
